module.exports = __webpack_public_path__ + "media/proksee-viewer/images/cb-move-left-d75a39ff2394256837e5ed2066dbafea.png";